import "@/public/styles/globals.css";
import { NextComponentType } from "next";
import { SessionProvider, useSession } from "next-auth/react";
import type { AppProps } from "next/app";
import CustomScripts from "@/components/layout/CustomScripts";
import Navbar from "@/components/layout/Navbar";
import Login from "../components/layout/Login";
import ObservabilityInit from "@/components/Observability";
import CheckConnection from "@/components/CheckConnectivity";

type CustomAppProps = AppProps & {
  Component: NextComponentType & { isAuth?: boolean };
};

const App = ({ Component, pageProps }: CustomAppProps) => {
  return (
    <SessionProvider>
      <ObservabilityInit />
      <CustomScripts />
      {Component.isAuth ? (
        <Auth>
          <Component {...pageProps} />
        </Auth>
      ) : (
        // 404 & Login Page,
        <Component {...pageProps} />
      )}
    </SessionProvider>
  );
};

type AuthProps = {
  children: React.ReactElement;
};

const Auth = ({ children }: AuthProps) => {
  const { status } = useSession();

  if (status === "authenticated") {
    return (
      <div>
        <CheckConnection />
        <Navbar />
        {children}
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Login />;
  }

  return (
    <div className="container font-weight-bold text-center">
      <p className="mt-4">Loading...</p>
    </div>
  );
};

export default App;
